import { Layout, Tag } from '@loadsmart/miranda-react'

import { intSizes } from 'core/miranda-styles/screen'
import useWindowWidth from 'core/ui/hooks/useWindowWidth'

export type ShipmentIdentifiersProps = {
  identifiers?: Array<string>
}

export function ShipmentIdentifiers({ identifiers }: ShipmentIdentifiersProps) {
  const windowWidth = useWindowWidth()
  const tagSize = windowWidth <= intSizes.md ? 'small' : 'default'

  const hasIdentifiers = Array.isArray(identifiers) && identifiers.length > 0
  if (!hasIdentifiers) return null

  return (
    <Layout.Group gap="spacing-2" style={{ flexWrap: 'nowrap' }}>
      {identifiers.map(identifier => (
        <Tag key={identifier} size={tagSize}>
          {identifier}
        </Tag>
      ))}
    </Layout.Group>
  )
}
